import React from 'react';
import { Pagination, PaginationItem } from '@mui/material';
import { IoMdArrowDropleft, IoMdArrowDropright } from 'react-icons/io';
import { useMediaQueries } from '../../usecontext/UseProvider';

const PaginationSection = ({ page, onPageChange, total, limit }) => {
  const { isSmallScreen } = useMediaQueries();
  const totalPages = Math.ceil(total / limit);

  return (
    <Pagination
      count={totalPages}
      page={page}
      onChange={onPageChange}
      size={isSmallScreen ? 'small' : 'large'}
      sx={{ display: 'flex', justifyContent: 'center' }}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          components={{
            previous: () => <IoMdArrowDropleft size={isSmallScreen ? 20 : 40} />,
            next: () => <IoMdArrowDropright size={isSmallScreen ? 20 : 40} />,
          }}
          sx={{
            mx: '8px',
            fontSize: { sm: '18px', xs: '14px' },
            border: '1px solid #01A0E2',
            '&.MuiPaginationItem-previousNext': {
              px: 0,
              border: 'none',
              color: '#000',
              '&:hover': {
                backgroundColor: 'transparent',
              },
            },
            '&.Mui-disabled': {
              color: '#000',
              opacity: 1,
            },
            '&.Mui-selected': {
              backgroundColor: '#01A0E2',
              boxShadow: '0px 7px 16px 0px #00000024',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#01A0E2',
              },
            },
          }}
        />
      )}
    />
  );
};

export default PaginationSection;